import moment from 'moment';

const getStockListResponse = (response) => {
  const stocks = response.stocks.map((stock) => ({
    ...stock,
    totalAvailableStock: stock?.productStorages.reduce((total, storage) => total + storage.availableStock, 0),
  }));
  return {
    ...response,
    stocks,
    lastSync: moment(new Date(response.lastSync)).format('DD/MM/YYYY, HH:mm:ss'),
  };
};

export default getStockListResponse;
